import React from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import { isRTL } from "../../../utils";

export default function Filter({ show, children }) {
  return (
    <>
      <Offcanvas
        show={show}
        backdrop="static"
        placement={isRTL ? "start" : "end"}
        className="filter-width overflow-y-scroll"
      >
        {children}
      </Offcanvas>
    </>
  );
}
